// Get the catalogId from details or details.associationEntity
// or from the failedRelationship if it exists
export function getCatalogId(details) {
    if (details?.failedRelationship?.parentRightsLineId != null) {
        return details.failedRelationship.parentRightsLineId;
    }
    if (details?.failedRelationship === null) {
        if (details?.associationEntity == null && details?.catalogId > -1) {
            return details.catalogId;
        }
        if (details?.associationEntity != null) {
            if (details?.associationData?.catalogId > -1) {
                return details.associationData.catalogId;
            }
            if (details?.associationData?.catalogId === -1 && details?.catalogId > -1) {
                return details.catalogId;
            }
        }
    }
    return undefined;
}

// Get the dealId from details or details.associationEntity
// or from the failedRelationship if it exists
export function getDealId(details) {
    if (details?.failedRelationship?.parentRightsLineId != null) {
        return details.failedRelationship.parentRightsLineId;
    }
    if (details?.failedRelationship === null) {
        if (details?.associationEntity == null && details?.dealId > -1) {
            return details.dealId;
        }
        if (details?.associationEntity != null) {
            if (details?.associationData?.dealId > -1) {
                return details.associationData.dealId;
            }
            if (details?.associationData?.dealId === -1 && details?.dealId > -1) {
                return details.dealId;
            }
        }
    }
    return undefined;
}

// Show the static inputs if there is a valid dealId or catalogId in details or details.associationEntity
// or if there is a failed relationship of that type
export function getStaticInputVisibilityFlags(details) {
    const shouldShowDealStaticInput =
        (details?.failedRelationship === null &&
            (details?.dealId > -1 ||
                (details?.associationEntity != null &&
                    details?.associationEntity?.dealId > -1))) ||
        (details?.failedRelationship != null &&
            details?.failedRelationship?.parentEntityType === 'DEAL');

    const shouldShowCatalogStaticInput =
        (details?.failedRelationship === null &&
            (details?.catalogId > -1 ||
                (details?.associationEntity != null &&
                    details?.associationEntity?.catalogId > -1))) ||
        (details?.failedRelationship != null &&
            details?.failedRelationship?.parentEntityType === 'CATALOG_ITEM');

    return { shouldShowDealStaticInput, shouldShowCatalogStaticInput };
}

// Show the search inputs only if there is no failed relationship and there is no valid
// dealId or catalogId in details or details.associationEntity
export function getSearchInputVisibility(details) {

    const shouldShowDealSearch =
        details?.failedRelationship === null &&
        !(
            details?.dealId > -1 ||
            (details?.associationEntity != null &&
                details?.associationEntity?.dealId > -1)
        );

    const shouldShowCatalogSearch =
        details?.failedRelationship === null &&
        !(
            details?.catalogId > -1 ||
            (details?.associationEntity != null &&
                details?.associationEntity?.catalogId > -1)
        );

    return { shouldShowDealSearch, shouldShowCatalogSearch };
}

// Disable the create association button if:
// - there is no failed relationship
// - and neither a valid dealId nor catalogId is provided in details or details.associationData
export function isCreateAssociationDisabled(details) {
    if (details?.failedRelationship === null) {
        const dataDealIdValid = details?.dealId > -1;
        const dataCatalogIdValid = details?.catalogId > -1;
        const assocData = details?.associationData;
        const assocDealIdValid = assocData?.dealId > -1;
        const assocCatalogIdValid = assocData?.catalogId > -1;

        return !(
            (dataDealIdValid && dataCatalogIdValid) ||
            (assocDealIdValid && assocCatalogIdValid) ||
            (dataDealIdValid && assocCatalogIdValid) ||
            (assocDealIdValid && dataCatalogIdValid)
        );
    }
    return false;
}

export function getAssociationIdsAndErrors({ dealNotFound, catalogNotFound, dealSelected, catalogSelected, details }) {
    const errors = {};
    let dealId = null, catalogId = null, previousDeal = null, previousCatalog = null;

    // Deal logic
    if (dealNotFound && !dealSelected) {
        errors.dealSelected = 'Deal is mandatory and cannot be blank';
    } else if (dealNotFound && dealSelected) {
        dealId = dealSelected.id;
        previousDeal = details?.failedRelationship?.parentRightsLineId;
    } else if (details?.failedRelationship?.parentEntityType === 'DEAL') {
        dealId = details.failedRelationship.parentRightsLineId;
    }

    // Catalog logic
    if (catalogNotFound && !catalogSelected) {
        errors.catalogSelected = 'Catalog is mandatory and cannot be blank';
    } else if (catalogNotFound && catalogSelected) {
        catalogId = catalogSelected.id;
        previousCatalog = details?.failedRelationship?.parentRightsLineId;
    } else if (details?.failedRelationship?.parentEntityType === 'CATALOG_ITEM') {
        catalogId = details.failedRelationship.parentRightsLineId;
    }

    return { errors, dealId, catalogId, previousDeal, previousCatalog };
}